export const FACT_LOADED = '@fact/FACT_LOADED';
export const FACT_NOT_LOADED = '@fact/FACT_NOT_LOADED';
export const FACT_OPENED = '@fact/FACT_OPENED';
export const UPDATE_TRY = '@fact/UPDATE_TRY';